import React, { useState } from "react";
import { MoreInfo } from "../../entrypoints/dashboard/layouts/dashboard/sidebar/icons/icons/icons";
import { Tooltip } from "@paylixecommerce/shared/components";

const PasswordToggleIcon = ({ isVisible }) => isVisible ? 
	<svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M10.5 4.16667C14.1667 4.16667 17.1667 6.66667 19.1667 10C17.1667 13.3333 14.1667 15.8333 10.5 15.8333C6.83333 15.8333 3.83333 13.3333 1.83333 10C3.83333 6.66667 6.83333 4.16667 10.5 4.16667Z" stroke="#A2AAB4" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
		<path d="M10.5 12.5C11.8807 12.5 13 11.3807 13 10C13 8.61929 11.8807 7.5 10.5 7.5C9.11929 7.5 8 8.61929 8 10C8 11.3807 9.11929 12.5 10.5 12.5Z" stroke="#A2AAB4" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
	</svg> :
	<svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M3.21106 2.5L18.3487 17.5" stroke="#A2AAB4" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
		<path d="M9.58898 8.82031C9.27338 9.13283 9.09598 9.55677 9.09583 9.99889C9.09567 10.441 9.27276 10.8651 9.58814 11.1778C9.90352 11.4905 10.3314 11.6663 10.7775 11.6665C11.2237 11.6666 11.6517 11.4912 11.9673 11.1786" stroke="#A2AAB4" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
		<path d="M8.56224 4.46828C9.28331 4.26388 10.0299 4.16148 10.7799 4.16411C14.1438 4.16411 16.9468 6.10828 19.1897 9.99745C18.5354 11.1316 17.834 12.1008 17.0847 12.9041M15.285 14.4549C13.9134 15.3716 12.4131 15.8308 10.7799 15.8308C7.41599 15.8308 4.61301 13.8866 2.37012 9.99745C3.52142 8.00161 4.81989 6.51828 6.26553 5.54661" stroke="#A2AAB4" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
	</svg>;

const Text = ({
	label,
	disabled,
				  autoComplete,
	tooltip,
	lang,
	style,
	type,
	isError,
	value,
	wrapperClassName,
	noteUnder,
	name,
	nowrap,
	className,
	placeholder,
	min,
	step,
	handleChange,
	handleBlur,
	onChange,
	showPassword,
	values,
	note,
	touched,
	errors,
	onClick,
	icon,
	noPadding = false,
}) => {

	let isInvalid = isError ? isError : errors[name] && touched[name];
	let [isVisible, setVisible] = useState(false);

	return <div className={`${noPadding ? '' : 'mb-4'} ${wrapperClassName ? wrapperClassName : ""} ${showPassword || icon ? "position-relative" : ""}`} onClick={onClick}>
		<div>
			{label && <label className={`paylixecommerce-label ${nowrap ? 'text-nowrap' : ''}`} htmlFor={name}>{label}</label>}
			{tooltip &&
				<span className="ml-1">
					<Tooltip tooltipText={tooltip} name={name}>
						<MoreInfo />
					</Tooltip>
				</span>
			}
		</div>
		{note && !noteUnder && <p className="paylixecommerce-note">{note}</p>}

		<input
			autoComplete={autoComplete ? autoComplete : "off"}
			type={(showPassword ? (isVisible ? "text" : "password") : type) || "text"}
			id={name}
			name={name}
			style={style}
			lang={lang}
			disabled={disabled ? "disabled" : ""}
			placeholder={placeholder}
			step={step}
			onChange={(e) => {
				handleChange(e);
				if(onChange) {
					onChange(e)
				}
			}}
			onBlur={handleBlur}
			min={min}
			value={typeof value !== 'undefined' ? value : values[name]}
			className={`paylixecommerce-input ${className} ${isInvalid && 'is-invalid'}`}
		/>
		{showPassword ? <div className="paylixecommerce-input-visible" style={{ top: 40 }} onClick={() => setVisible(!isVisible)}><PasswordToggleIcon isVisible={isVisible} /></div> : null}
		{icon ? <div className="paylixecommerce-input-visible">{icon}</div> : null}

		{isInvalid && <div className="invalid-feedback">
			{isError ? isError : errors[name]}
		</div>}
		{note && noteUnder && <p className="paylixecommerce-note">{note}</p>}
	</div>
}

export default Text;
